

















import { Component, Mixins } from "vue-property-decorator";
import { NumberInput } from "../../../../../base/components/system";
import { ICopyLinkedCheckBehavior } from "../../../../../documaker/domain/format/objects";
import { ModelEditableMixin } from "../../../../../base/components/system/mixins";

@Component({
  components: {
    NumberInput,
  }
})
export default class CopyLinkedCheckBehaviorEditor extends Mixins(ModelEditableMixin) {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: ICopyLinkedCheckBehavior) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: ICopyLinkedCheckBehavior) => T, defaultValue: T) => T;

  get isEnable(): boolean {
    return this.readPropertyOrDefault(s => s.isEnable, false);
  }

  set isEnable(value: boolean) {
    this.writePropertyWhenValid(s => s.isEnable = value);
  }

  get no(): number {
    return this.readPropertyOrDefault(s => s.no, 1);
  }

  set no(value: number) {
    this.writePropertyWhenValid(s => s.no = value);
  }
  
  correct(value: number): number {
    return Math.floor(value);
  }

  isValid(value: number): boolean {
    return (0 < value) && (value < 100);
  }
}
